export default {
    mounted(el, binding) {
      updateColor(el, binding.value);
    },
    updated(el, binding) {
      updateColor(el, binding.value);
    }
  };
  
  function updateColor(el, value) {
    if (value === 1) {
      el.style.color = 'red';
      el.style.fontWeight = 'bold';
    } else {
      el.style.color = '';
      el.style.fontWeight = '';
    }
  }